// extracted by mini-css-extract-plugin
export var divider = "_fw-7";
export var itemsToggle = "_fw-8";
export var mergeModal = "_fw-1";
export var optionCard = "_fw-4";
export var radioGroup = "_fw-6";
export var radioOption = "_fw-0";
export var selected = "_fw-5";
export var shipmentOptions = "_fw-2";
export var tableOptions = "_fw-3";